(() => {
  const T = window.theme || { routes: { root: '/', cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart', search: '/search/suggest' }, strings: {}, delivery: {} };
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const debounce = (fn, ms = 300) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const store = {
    get(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  const formatMoney = (cents, format = T.moneyFormat || '₹{{amount}}') => {
    const value = Number(cents) / 100;
    const fmt = (n, d, ts = ',', ds = '.') => {
      const [i, f] = n.toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return fmt(value, 0);
      if (k === 'amount_with_comma_separator') return fmt(value, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(value, 0, '.', ',');
      return fmt(value, 2);
    });
  };

  const toast = (msg) => {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 2400);
  };

  /* Dialogs & drawers */
  const openDialog = (dlg) => {
    if (!dlg || dlg.open) return;
    dlg.showModal();
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => dlg.classList.add('is-open'));
    if (dlg.id === 'SearchModal') setTimeout(() => $('[data-search-input]', dlg)?.focus(), 50);
  };
  const closeDialog = (dlg) => {
    if (!dlg || !dlg.open) return;
    dlg.classList.remove('is-open');
    const isDrawer = dlg.classList.contains('drawer');
    setTimeout(() => {
      dlg.close();
      if (!$$('dialog[open]').length) document.documentElement.style.overflow = '';
    }, isDrawer ? 320 : 0);
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openDialog($(opener.dataset.open)); return; }
    const closer = e.target.closest('[data-close]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }
    if (e.target.tagName === 'DIALOG') closeDialog(e.target);
  });
  document.addEventListener('cancel', (e) => {
    if (e.target.tagName === 'DIALOG') { e.preventDefault(); closeDialog(e.target); }
  }, true);

  /* Header */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Announcement rotator */
  $$('[data-announce]').forEach((bar) => {
    const items = $$('.announce__item', bar);
    if (items.length < 2) return;
    let i = 0;
    const go = (n) => {
      items[i].classList.remove('is-active');
      items[i].classList.add('is-leaving');
      const prev = items[i];
      setTimeout(() => prev.classList.remove('is-leaving'), 450);
      i = (n + items.length) % items.length;
      items[i].classList.add('is-active');
    };
    let timer = setInterval(() => go(i + 1), Number(bar.dataset.interval) || 4000);
    const reset = () => { clearInterval(timer); timer = setInterval(() => go(i + 1), Number(bar.dataset.interval) || 4000); };
    $('[data-announce-next]', bar)?.addEventListener('click', () => { go(i + 1); reset(); });
    $('[data-announce-prev]', bar)?.addEventListener('click', () => { go(i - 1); reset(); });
  });

  /* Countdowns */
  const initCountdowns = () => $$('[data-countdown]').forEach((el) => {
    const end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) return;
    if (el.hasAttribute('data-hide-expired') && end < Date.now()) { el.hidden = true; return; }
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      let diff = Math.max(0, end - Date.now()) / 1000;
      const d = Math.floor(diff / 86400); diff -= d * 86400;
      const h = Math.floor(diff / 3600); diff -= h * 3600;
      const m = Math.floor(diff / 60); const s = Math.floor(diff - m * 60);
      const set = (sel, v) => { const n = $(sel, el); if (n) n.textContent = pad(v); };
      set('[data-d]', d); set('[data-h]', h); set('[data-m]', m); set('[data-s]', s);
    };
    tick();
    setInterval(tick, 1000);
  });
  initCountdowns();

  /* Copy codes */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-copy]');
    if (!btn) return;
    e.preventDefault();
    const code = btn.dataset.copy;
    (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).catch(() => {}).finally(() => {
      toast(`${code} ${T.strings.copied || 'copied'}`);
      fetch(`${T.routes.root}discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' }).catch(() => {});
    });
  });

  /* Hero slideshow */
  $$('[data-slideshow]').forEach((root) => {
    const track = $('[data-slides]', root);
    const slides = $$('.hero__slide', root);
    const dots = $$('[data-dot]', root);
    const interval = Number(root.dataset.interval) || 5000;
    root.style.setProperty('--hero-interval', `${interval}ms`);
    let index = 0; let timer;
    const setActive = (n) => {
      index = n;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === n));
      dots.forEach((d, k) => { d.classList.remove('is-active'); if (k === n) { void d.offsetWidth; d.classList.add('is-active'); } });
    };
    const go = (n) => {
      const next = (n + slides.length) % slides.length;
      track.scrollTo({ left: slides[next].offsetLeft, behavior: 'smooth' });
      setActive(next);
    };
    const start = () => { if (root.dataset.autoplay === 'true' && slides.length > 1) { clearInterval(timer); timer = setInterval(() => go(index + 1), interval); } };
    setActive(0);
    start();
    $('[data-next]', root)?.addEventListener('click', () => { go(index + 1); start(); });
    $('[data-prev]', root)?.addEventListener('click', () => { go(index - 1); start(); });
    dots.forEach((d) => d.addEventListener('click', () => { go(Number(d.dataset.dot)); start(); }));
    track.addEventListener('scroll', debounce(() => {
      const n = Math.round(track.scrollLeft / track.clientWidth);
      if (n !== index) setActive(n);
    }, 80), { passive: true });
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', start);
  });

  /* Sliders */
  const initSliders = (scope = document) => $$('[data-slider]', scope).forEach((slider) => {
    if (slider._init) return;
    slider._init = true;
    const track = $('[data-slider-track]', slider) || slider.firstElementChild;
    const prev = $('[data-slider-prev]', slider);
    const next = $('[data-slider-next]', slider);
    if (!track || !prev || !next) return;
    const update = () => {
      prev.disabled = track.scrollLeft < 5;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
    };
    const step = () => (track.firstElementChild?.getBoundingClientRect().width || 300) + 20;
    prev.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
    track.addEventListener('scroll', debounce(update, 60), { passive: true });
    window.addEventListener('resize', debounce(update, 150));
    update();
  });
  initSliders();

  /* Tabs */
  $$('[data-tabs]').forEach((root) => {
    const tabs = $$('[data-tab]', root);
    const panels = $$('[data-panel]', root);
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((t) => { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab); });
      panels.forEach((p) => { p.hidden = p.dataset.panel !== tab.dataset.tab; });
      const panel = panels.find((p) => !p.hidden);
      if (panel) { panel._init = false; $$('[data-slider]', panel).forEach((s) => { s._init = false; }); initSliders(panel); }
    }));
  });

  /* Cart */
  const cartDrawer = () => $('#CartDrawer');
  const updateCount = (count) => $$('[data-cart-count]').forEach((el) => {
    el.textContent = count;
    el.classList.toggle('is-empty', count === 0);
    el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
  });
  const renderDrawer = (html) => {
    const drawer = cartDrawer();
    if (!drawer || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-cart-drawer-inner]', doc);
    const current = $('[data-cart-drawer-inner]', drawer);
    if (fresh && current) current.replaceWith(fresh);
    initSliders(drawer);
  };
  const refreshCart = async () => {
    const res = await fetch(`${T.routes.cart}.js`, { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    updateCount(cart.item_count);
    return cart;
  };
  const addToCart = async (items, button) => {
    button?.classList.add('is-loading');
    try {
      const wantsDrawer = T.cartType === 'drawer' && cartDrawer();
      const body = { items };
      if (wantsDrawer) body.sections = 'cart-drawer';
      const res = await fetch(`${T.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.cartError);
      await refreshCart();
      if (wantsDrawer) {
        renderDrawer(data.sections && data.sections['cart-drawer']);
        openDialog(cartDrawer());
      } else {
        toast(T.strings.added || 'Added to cart');
      }
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return true;
    } catch (err) {
      toast(err.message || T.strings.cartError);
      return false;
    } finally {
      button?.classList.remove('is-loading');
    }
  };
  const changeLine = async (key, quantity) => {
    const inPage = $('[data-cart-page]');
    const drawer = cartDrawer();
    drawer?.classList.add('is-busy');
    try {
      const res = await fetch(`${T.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: drawer ? 'cart-drawer' : undefined })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.cartError);
      updateCount(data.item_count);
      if (inPage) { window.location.reload(); return; }
      renderDrawer(data.sections && data.sections['cart-drawer']);
    } catch (err) {
      toast(err.message || T.strings.cartError);
    } finally {
      drawer?.classList.remove('is-busy');
    }
  };

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && T.cartType === 'drawer' && cartDrawer()) { e.preventDefault(); openDialog(cartDrawer()); return; }
    const qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); addToCart([{ id: Number(qa.dataset.quickAdd), quantity: 1 }], qa); return; }
    const qc = e.target.closest('[data-qty-change]');
    if (qc) { e.preventDefault(); changeLine(qc.dataset.key, Number(qc.dataset.qtyChange)); }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-coupon-form]');
    if (!form) return;
    e.preventDefault();
    const code = form.code.value.trim().toUpperCase();
    if (!code) return;
    const msg = $('[data-coupon-msg]', form.parentElement);
    await fetch(`${T.routes.root}discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' }).catch(() => {});
    if (msg) msg.textContent = `✓ ${code} will be applied at checkout`;
  });

  document.addEventListener('input', debounce((e) => {
    if (!e.target.matches('[data-cart-note]')) return;
    fetch(`${T.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: e.target.value })
    });
  }, 600));

  /* Product page */
  $$('[data-product-section]').forEach((section) => {
    const variants = JSON.parse($('[data-variants]', section)?.textContent || '[]');
    const form = $('[data-product-form]', section);
    const idInput = $('[data-variant-id]', section);
    const atc = $('[data-atc]', section);
    const atcText = $('[data-atc-text]', section);
    const buyNow = $('[data-buy-now]', section);
    const picker = $('[data-variant-picker]', section);
    const track = $('[data-media-track]', section);
    const dots = $$('.pdp__dot', section);
    const sticky = $('[data-sticky-atc]');
    const lowStock = $('[data-low-stock]', section);
    let current = section.dataset.sizePending === 'true' ? null : (variants.find((v) => String(v.id) === idInput?.value) || variants[0]);
    const flagMissing = () => {
      if (!picker) return;
      picker.classList.remove('is-missing'); void picker.offsetWidth; picker.classList.add('is-missing');
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      toast(T.strings.selectSize || 'Please select a size');
    };

    const selectedOptions = () => $$('fieldset[data-option-index]', picker || section).map((fs) => $('input:checked', fs)?.value);

    const updateAvailability = () => {
      if (!picker) return;
      const sel = selectedOptions();
      $$('fieldset[data-option-index]', picker).forEach((fs) => {
        const idx = Number(fs.dataset.optionIndex);
        $$('input', fs).forEach((input) => {
          const label = input.nextElementSibling;
          const ok = variants.some((v) => v.available && v.options[idx] === input.value && v.options.every((o, k) => k === idx || k > idx || o === sel[k]));
          label?.classList.toggle('is-unavailable', !ok);
        });
      });
    };

    const scrollToMedia = (mediaId) => {
      if (!track || !mediaId) return;
      const el = $(`[data-media-id="${mediaId}"]`, track);
      if (!el) return;
      if (window.matchMedia('(min-width: 990px)').matches) {
        if (el !== track.firstElementChild) track.prepend(el);
      } else {
        track.scrollTo({ left: el.offsetLeft, behavior: 'smooth' });
      }
    };

    const renderVariant = (v) => {
      current = v;
      const priceWrap = $('[data-price-wrap]', section);
      const save = $('[data-save]', section);
      if (!v) {
        const incomplete = selectedOptions().some((x) => x === undefined);
        if (atc) atc.disabled = !incomplete;
        if (buyNow) buyNow.disabled = !incomplete;
        if (atcText) atcText.textContent = incomplete ? (T.strings.selectSize || 'Select a size') : T.strings.unavailable;
        return;
      }
      picker?.classList.remove('is-missing');
      if (idInput) idInput.value = v.id;
      if (priceWrap) {
        const sale = v.compare_at_price > v.price;
        const pct = sale ? Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price) : 0;
        priceWrap.innerHTML = `<div class="price price--large${sale ? ' price--sale' : ''}"><span class="price__current">${formatMoney(v.price)}</span>${sale ? `<s class="price__compare">${formatMoney(v.compare_at_price)}</s><span class="price__off">${pct}% OFF</span>` : ''}</div>`;
        if (save) {
          save.hidden = !sale;
          if (sale) save.textContent = (T.strings.save || 'You save [amount]').replace('[amount]', formatMoney(v.compare_at_price - v.price));
        }
      }
      if (atc) atc.disabled = !v.available;
      if (buyNow) buyNow.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      if (lowStock) {
        const low = v.inventory !== null && v.inventory > 0 && v.inventory <= (Number(section.dataset.lowStock) || 5);
        lowStock.hidden = !low;
        const txt = $('[data-low-stock-text]', lowStock);
        if (low && txt) txt.textContent = (T.strings.onlyLeft || 'Only [count] left').replace('[count]', v.inventory);
        const bar = $('[data-stock-bar]', lowStock);
        if (bar && low) bar.style.width = Math.max(8, Math.min(100, (v.inventory * 100) / ((Number(section.dataset.lowStock) || 5) * 2))) + '%';
      }
      if (sticky) {
        const sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = formatMoney(v.price);
        const sv = $('[data-sticky-variant]', sticky); if (sv && v.title !== 'Default Title') sv.textContent = v.title;
        const sb = $('[data-sticky-btn]', sticky); if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? T.strings.addToCart : T.strings.soldOut; }
      }
      scrollToMedia(v.media_id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    };

    picker?.addEventListener('change', (e) => {
      const fs = e.target.closest('fieldset');
      const lbl = $('[data-selected-value]', fs);
      if (lbl) lbl.textContent = e.target.value;
      const sel = selectedOptions();
      const match = variants.find((v) => v.options.every((o, k) => o === sel[k]));
      renderVariant(match);
      updateAvailability();
    });
    updateAvailability();

    $$('[data-qty-step]', section).forEach((b) => b.addEventListener('click', () => {
      const input = $('input', b.parentElement);
      input.value = Math.max(1, Number(input.value || 1) + Number(b.dataset.qtyStep));
    }));

    form?.addEventListener('submit', (e) => {
      if (!current) { e.preventDefault(); flagMissing(); return; }
      if (e.submitter && e.submitter.hasAttribute('data-buy-now')) return;
      e.preventDefault();
      if (!current.available) return;
      const qty = Number(form.querySelector('[name="quantity"]')?.value || 1);
      const props = {};
      new FormData(form).forEach((val, key) => { const m = key.match(/^properties\[(.+)\]$/); if (m && val) props[m[1]] = val; });
      const item = { id: current.id, quantity: qty };
      if (Object.keys(props).length) item.properties = props;
      addToCart([item], atc);
    });

    if (sticky && atc) {
      document.body.appendChild(sticky);
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        $('[data-sticky-btn]', sticky).tabIndex = show ? 0 : -1;
      });
      io.observe(atc);
      $('[data-sticky-btn]', sticky).addEventListener('click', () => {
        const needsChoice = picker && !current;
        if (needsChoice) { flagMissing(); return; }
        form.requestSubmit ? form.requestSubmit(atc) : atc.click();
      });
    }

    if (track && dots.length) {
      track.addEventListener('scroll', debounce(() => {
        const n = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, k) => d.classList.toggle('is-active', k === n));
      }, 50), { passive: true });
    }

    const lightbox = $('[data-lightbox]');
    $$('[data-zoom]', section).forEach((btn) => btn.addEventListener('click', () => {
      if (!lightbox) return;
      openDialog(lightbox);
      const lt = $('[data-lightbox-track]', lightbox);
      const n = Number(btn.dataset.zoom);
      requestAnimationFrame(() => { lt.scrollLeft = lt.clientWidth * n; });
    }));

    const pinForm = $('[data-pincode-form]', section);
    pinForm?.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = $('[data-pincode]', pinForm);
      const out = $('[data-pincode-result]', section);
      const pin = input.value.trim();
      const list = (s) => String(s || '').split(/[\s,]+/).filter(Boolean);
      if (!/^[1-9][0-9]{5}$/.test(pin)) { out.innerHTML = `<p class="is-err">${T.strings.pincodeInvalid}</p>`; return; }
      if (list(T.delivery.blocked).includes(pin)) { out.innerHTML = `<p class="is-err">${T.strings.pincodeBlocked}</p>`; return; }
      const cutoff = Number(T.delivery.cutoff) || 14;
      const now = new Date();
      const extra = now.getHours() >= cutoff ? 1 : 0;
      const addDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n + extra); if (d.getDay() === 0) d.setDate(d.getDate() + 1); return d; };
      const f = (d) => d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
      const from = f(addDays(Number(T.delivery.min) || 3));
      const to = f(addDays(Number(T.delivery.max) || 7));
      const cod = !list(T.delivery.noCod).includes(pin);
      const check = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m5 12 5 5 9-10"/></svg>';
      out.innerHTML = `<p>${check}<span>${(T.strings.pincodeOk || '').replace('[from]', from).replace('[to]', to)}</span></p><p>${check}<span>${cod ? T.strings.codYes : T.strings.codNo}</span></p>`;
      store.set('rz-pincode', pin);
    });
    const savedPin = store.get('rz-pincode');
    if (pinForm && savedPin) { $('[data-pincode]', pinForm).value = savedPin; pinForm.requestSubmit ? pinForm.requestSubmit() : null; }

    $('[data-share]', section)?.addEventListener('click', async (e) => {
      const b = e.currentTarget;
      if (navigator.share) { navigator.share({ title: b.dataset.title, url: b.dataset.url }).catch(() => {}); }
      else { navigator.clipboard?.writeText(b.dataset.url); toast(T.strings.copied); }
    });

    const handle = section.dataset.handle;
    if (handle) {
      const list = (store.get('rz-recent') || []).filter((h) => h !== handle);
      list.unshift(handle);
      store.set('rz-recent', list.slice(0, 12));
    }
  });

  /* Recommendations */
  $$('[data-recommendations]').forEach((el) => {
    const load = () => fetch(el.dataset.url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initSliders(el); observeReveal(el); }
    }).catch(() => {});
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
    io.observe(el);
  });

  /* Recently viewed */
  $$('[data-recently-viewed]').forEach(async (el) => {
    const handles = (store.get('rz-recent') || []).filter((h) => h !== el.dataset.current).slice(0, 8);
    if (!handles.length) return;
    const track = $('[data-recent-track]', el);
    const products = (await Promise.all(handles.map((h) => fetch(`${T.routes.root}products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)))).filter(Boolean);
    if (!products.length) return;
    track.innerHTML = products.map((p) => {
      const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=500` : '';
      const sale = p.compare_at_price > p.price;
      return `<article class="card"><div class="card__media"><a href="${p.url}" class="card__link" aria-label="${p.title.replace(/"/g, '&quot;')}">${img ? `<img class="card__img" src="${img}" alt="" loading="lazy">` : ''}</a></div><div class="card__info"><h3 class="card__title"><a href="${p.url}">${p.title}</a></h3><div class="price${sale ? ' price--sale' : ''}"><span class="price__current">${formatMoney(p.price)}</span>${sale ? `<s class="price__compare">${formatMoney(p.compare_at_price)}</s>` : ''}</div></div></article>`;
    }).join('');
    el.hidden = false;
  });

  /* Collection filters */
  const coll = $('[data-collection]');
  if (coll) {
    const sectionId = coll.dataset.section;
    const filterForm = $('[data-filter-form]');
    const render = async (url) => {
      const target = $('#CollectionSection');
      target?.classList.add('is-loading');
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      try {
        const html = await fetch(u).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const freshColl = $('#CollectionSection', doc);
        const freshForm = $('[data-filter-form]', doc);
        const openState = $$('details.filter', filterForm).map((d) => d.open);
        if (freshColl) $('#CollectionSection').replaceWith(freshColl);
        if (freshForm && filterForm) {
          filterForm.innerHTML = freshForm.innerHTML;
          $$('details.filter', filterForm).forEach((d, k) => { if (openState[k] !== undefined) d.open = openState[k]; });
        }
        const freshFoot = $('#FilterDrawer .drawer__foot', doc);
        const foot = $('#FilterDrawer .drawer__foot');
        if (freshFoot && foot) foot.innerHTML = freshFoot.innerHTML;
        u.searchParams.delete('section_id');
        window.history.replaceState({}, '', u);
        observeReveal($('#CollectionSection'));
      } finally {
        $('#CollectionSection')?.classList.remove('is-loading');
      }
    };
    const fromForm = () => {
      const fd = new FormData(filterForm);
      const sortSel = $('#CollectionSection select[name="sort_by"]');
      if (sortSel) fd.set('sort_by', sortSel.value);
      const params = new URLSearchParams();
      fd.forEach((v, k) => { if (v !== '') params.append(k, v); });
      render(`${window.location.pathname}?${params.toString()}`);
    };
    document.addEventListener('change', (e) => { if (e.target.matches('[data-filter-input]')) fromForm(); });
    document.addEventListener('input', debounce((e) => { if (e.target.matches('[data-filter-input][type="number"]')) fromForm(); }, 700));
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-filter-link]');
      if (!link) return;
      e.preventDefault();
      render(link.href);
    });
  }

  /* Predictive search */
  const searchForm = $('[data-predictive-search]');
  if (searchForm) {
    const input = $('[data-search-input]', searchForm);
    const results = $('[data-search-results]');
    let controller;
    input.addEventListener('input', debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      controller?.abort();
      controller = new AbortController();
      try {
        const url = `${T.routes.search}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last`;
        const html = await fetch(url, { signal: controller.signal }).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        results.innerHTML = $('#shopify-section-predictive-search', doc)?.innerHTML || '';
      } catch (err) {}
    }, 250));
  }

  /* Offer popup */
  const popup = $('[data-popup]');
  if (popup) {
    const key = 'rz-popup-closed';
    const closedAt = store.get(key);
    const days = Number(popup.dataset.days) || 7;
    const posted = /customer_posted=true/.test(window.location.search) || popup.querySelector('.popup__success');
    const blocked = closedAt && Date.now() - closedAt < days * 864e5;
    if (posted) { openDialog(popup); }
    else if (!blocked && !window.Shopify?.designMode) {
      let shown = false;
      const show = () => { if (shown || $$('dialog[open]').length) return; shown = true; openDialog(popup); };
      setTimeout(show, Number(popup.dataset.delay) || 8000);
      if (popup.dataset.exit === 'true') document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY < 10) show(); });
    }
    popup.addEventListener('close', () => store.set(key, Date.now()));
  }

  /* Transparent header over hero */
  const overlayHeader = $('.header--overlay');
  if (overlayHeader) {
    const wrap = overlayHeader.closest('.shopify-section') || overlayHeader;
    const setH = () => document.documentElement.style.setProperty('--header-h', wrap.offsetHeight + 'px');
    const sync = () => overlayHeader.classList.toggle('is-transparent', window.scrollY < 20 && !overlayHeader.matches(':hover') && !overlayHeader.contains(document.activeElement));
    setH();
    window.addEventListener('resize', debounce(setH, 100));
    window.addEventListener('scroll', sync, { passive: true });
    overlayHeader.addEventListener('mouseenter', sync);
    overlayHeader.addEventListener('mouseleave', sync);
    overlayHeader.addEventListener('focusin', sync);
    overlayHeader.addEventListener('focusout', () => setTimeout(sync, 0));
    sync();
  }

  /* Wishlist */
  const WISH = 'rz-wish';
  const wishList = () => store.get(WISH) || [];
  const paintWish = () => {
    const list = wishList();
    $$('[data-wish]').forEach((b) => { const on = list.includes(b.dataset.wish); b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on)); });
    $$('[data-wish-count]').forEach((c) => { c.textContent = list.length; c.classList.toggle('is-empty', !list.length); });
  };
  const renderWishDrawer = async () => {
    const grid = $('[data-wishlist-grid]');
    const empty = $('[data-wishlist-empty]');
    if (!grid) return;
    const list = wishList();
    if (empty) empty.hidden = list.length > 0;
    if (!list.length) { grid.innerHTML = ''; return; }
    const items = (await Promise.all(list.map((h) => fetch(T.routes.root + 'products/' + h + '.js').then((r) => (r.ok ? r.json() : null)).catch(() => null)))).filter(Boolean);
    grid.innerHTML = items.map((p) => {
      const img = p.featured_image ? p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=500' : '';
      const v = (p.variants || []).find((x) => x.available);
      const sale = p.compare_at_price > p.price;
      return '<article class="card"><div class="card__media"><a href="' + p.url + '" class="card__link">' + (img ? '<img class="card__img" src="' + img + '" alt="" loading="lazy">' : '') + '</a><button type="button" class="card__wish is-active" data-wish="' + p.handle + '" aria-pressed="true"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 20s-7.5-4.6-9-9.3C2 7.4 4.2 4.5 7.3 4.5c2 0 3.4 1.1 4.7 2.8 1.3-1.7 2.7-2.8 4.7-2.8 3.1 0 5.3 2.9 4.3 6.2C19.5 15.4 12 20 12 20Z"/></svg></button></div><div class="card__info"><h3 class="card__title"><a href="' + p.url + '">' + p.title + '</a></h3><div class="price"><span class="price__current">' + formatMoney(p.price) + '</span>' + (sale ? '<s class="price__compare">' + formatMoney(p.compare_at_price) + '</s>' : '') + '</div>' + (v ? '<a href="' + p.url + '" class="btn btn--outline btn--sm">' + (T.strings.addToCart || 'Add') + '</a>' : '') + '</div></article>';
    }).join('');
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    const h = b.dataset.wish;
    let list = wishList();
    const on = list.includes(h);
    list = on ? list.filter((x) => x !== h) : [h, ...list];
    store.set(WISH, list.slice(0, 50));
    paintWish();
    toast(on ? (T.strings.wishRemoved || 'Removed from wishlist') : (T.strings.wishAdded || 'Saved to wishlist'));
    if (b.closest('#WishlistDrawer')) renderWishDrawer();
  });
  $('#WishlistDrawer')?.addEventListener('close', paintWish);
  document.addEventListener('click', (e) => { if (e.target.closest('[data-open="#WishlistDrawer"]')) renderWishDrawer(); });
  paintWish();

  /* Same-day dispatch countdown */
  $$('[data-dispatch]').forEach((el) => {
    const out = $('[data-dispatch-text]', el);
    const cutoff = Number(T.delivery.cutoff) || 14;
    const tick = () => {
      const now = new Date();
      const end = new Date(now); end.setHours(cutoff, 0, 0, 0);
      const sunday = now.getDay() === 0;
      if (!sunday && now < end) {
        const mins = Math.floor((end - now) / 60000);
        const h = Math.floor(mins / 60); const m = mins % 60;
        out.innerHTML = (T.strings.dispatchToday || '').replace('[time]', (h ? h + 'h ' : '') + m + 'm');
      } else {
        out.innerHTML = T.strings.dispatchTomorrow || '';
      }
      el.hidden = false;
    };
    tick();
    setInterval(tick, 30000);
  });

  /* Size finder */
  $$('[data-size-finder]').forEach((form) => {
    const ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
    const result = $('[data-size-result]', form);
    const out = $('[data-size-out]', form);
    let rec = null;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      let i = ORDER.indexOf(fd.get('usual')) + Number(fd.get('body') || 0) + Number(fd.get('fit') || 0);
      i = Math.max(0, Math.min(ORDER.length - 1, i));
      rec = ORDER[i];
      out.textContent = rec;
      result.classList.add('is-visible');
      store.set('rz-size', rec);
    });
    $('[data-size-apply]', form)?.addEventListener('click', () => {
      const section = form.closest('dialog')?.previousElementSibling ? document : document;
      const input = $$('[data-variant-picker] input[type="radio"]', section).find((x) => x.value.toUpperCase() === String(rec).toUpperCase());
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      closeDialog(form.closest('dialog'));
    });
  });
  const savedSize = store.get('rz-size');
  if (savedSize) $$('[data-variant-picker] .opt__pill').forEach((l) => { if (l.textContent.trim().toUpperCase() === String(savedSize).toUpperCase()) l.classList.add('is-recommended'); });

  /* Shop the look: hotspots + add all */
  $$('[data-look]').forEach((root) => {
    const spots = $$('[data-hotspot]', root);
    const items = $$('[data-look-item]', root);
    const activate = (n) => {
      spots.forEach((s, k) => s.classList.toggle('is-active', k === n));
      items.forEach((it, k) => it.classList.toggle('is-active', k === n));
    };
    spots.forEach((s) => s.addEventListener('click', () => { const n = Number(s.dataset.hotspot); activate(n); items[n]?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }));
    items.forEach((it, n) => it.addEventListener('mouseenter', () => activate(n)));
    $('[data-add-all]', root)?.addEventListener('click', (e) => {
      const ids = $$('[data-quick-add]', root).map((b) => Number(b.dataset.quickAdd));
      if (e.currentTarget.hasAttribute('data-include-current')) {
        const cur = $('[data-product-section] [data-variant-id]');
        if (cur) ids.unshift(Number(cur.value));
      }
      if (ids.length) addToCart(ids.map((id) => ({ id, quantity: 1 })), e.currentTarget);
    });
  });

  /* Collection grid density */
  const grid = $('[data-product-grid]');
  if (grid) {
    const apply = (n) => { grid.style.setProperty('--cols', n); $$('[data-grid]').forEach((b) => b.classList.toggle('is-active', b.dataset.grid === String(n))); };
    const saved = store.get('rz-grid');
    if (saved) apply(saved);
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-grid]');
      if (!b) return;
      const g = $('[data-product-grid]');
      if (g) { g.style.setProperty('--cols', b.dataset.grid); $$('[data-grid]').forEach((x) => x.classList.toggle('is-active', x === b)); store.set('rz-grid', b.dataset.grid); }
    });
  }

  /* Gift wrap toggle */
  document.addEventListener('change', (e) => {
    const box = e.target.closest('[data-gift-wrap]');
    if (!box) return;
    if (box.checked) addToCart([{ id: Number(box.dataset.giftWrap), quantity: 1 }], null);
    else if (box.dataset.key) changeLine(box.dataset.key, 0);
  });

  /* Reels: play video on hover / when visible */
  $$('[data-reel] video').forEach((v) => {
    const reel = v.closest('[data-reel]');
    reel.addEventListener('mouseenter', () => v.play().catch(() => {}));
    reel.addEventListener('mouseleave', () => v.pause());
    if (window.matchMedia('(hover: none)').matches) {
      new IntersectionObserver(([en]) => (en.isIntersecting ? v.play().catch(() => {}) : v.pause()), { threshold: 0.6 }).observe(v);
    }
  });

  /* Rekha line draw */
  if (document.body.classList.contains('line-anim') && 'IntersectionObserver' in window) {
    const lineIO = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-drawn'); lineIO.unobserve(en.target); }
    }), { rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('.rekha, .rekha-line').forEach((el) => lineIO.observe(el));
  } else { document.querySelectorAll('.rekha, .rekha-line').forEach((el) => el.classList.add('is-drawn')); }

  /* PDP thumbnails */
  document.querySelectorAll('[data-thumbs]').forEach((rail) => {
    const thumbs = Array.from(rail.querySelectorAll('[data-thumb]'));
    const gallery = rail.closest('[data-gallery]');
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const m = gallery.querySelector('[data-media-id="' + t.dataset.thumb + '"]');
      if (m) m.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => entries.forEach((en) => {
        if (!en.isIntersecting) return;
        thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === en.target.dataset.mediaId));
      }), { rootMargin: '-45% 0px -45% 0px' });
      gallery.querySelectorAll('[data-media-id]').forEach((m) => io.observe(m));
    }
  });

  /* Delivery ETA */
  document.querySelectorAll('[data-eta]').forEach((el) => {
    const min = Number(el.dataset.min) || 3, max = Number(el.dataset.max) || 7;
    const cutoff = Number(T.delivery.cutoff) || 14;
    const extra = new Date().getHours() >= cutoff ? 1 : 0;
    const day = (n) => { const d = new Date(); d.setDate(d.getDate() + n + extra); if (d.getDay() === 0) d.setDate(d.getDate() + 1); return d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' }); };
    const out = el.querySelector('[data-eta-text]');
    if (out && T.strings.etaText) out.innerHTML = T.strings.etaText.replace('[from]', day(min)).replace('[to]', day(max));
  });

  /* Scroll reveal */
  const revealIO = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => entries.forEach((en) => {
    if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); }
  }), { rootMargin: '0px 0px -8% 0px' }) : null;
  function observeReveal(scope = document) {
    if (!revealIO || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    $$('.s-head, .card, .cat-tile, .promo, .price-tile, .review, .story__body, .usp__item, .blog-card, .craft, .step, .reel, .artisan > *, .look-item', scope).forEach((el, i) => {
      if (el.classList.contains('reveal') || el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('reveal');
      el.style.transitionDelay = `${(i % 4) * 70}ms`;
      revealIO.observe(el);
    });
  }
  observeReveal();

  document.addEventListener('shopify:section:load', (e) => { initSliders(e.target); initCountdowns(); });
})();
